/**
 * Streetlovo Theme - Main JavaScript
 * Cart drawer logic moved to cart-drawer.js
 */

(function() {
  'use strict';

  // Theme Namespace
  window.Streetlovo = window.Streetlovo || {};
  const Streetlovo = window.Streetlovo;

  /**
   * Format money helper
   */
  Streetlovo.formatMoney = function(cents) {
    if (typeof cents === 'undefined' || cents === null) return '£0.00';
    const value = (cents / 100).toFixed(2);
    return '£' + value;
  };

  /**
   * Newsletter Popup
   */
  Streetlovo.newsletter = {
    popup: null,
    lastActiveElement: null,
    keydownBound: false,
    autoShowTimer: null,

    init: function() {
      this.popup = document.querySelector('[data-newsletter-popup]');
      if (!this.popup) return;
      this.bindEvents();
      if (!this.openFormState()) {
        this.scheduleAutoShow();
      }
    },

    bindEvents: function() {
      const self = this;

      document.querySelectorAll('[data-newsletter-open]').forEach(function(trigger) {
        if (trigger.dataset.streetlovoNewsletterOpenBound === 'true') return;
        trigger.dataset.streetlovoNewsletterOpenBound = 'true';
        trigger.addEventListener('click', function(e) {
          e.preventDefault();
          self.open();
        });
      });

      this.popup.querySelectorAll('[data-newsletter-close]').forEach(function(trigger) {
        if (trigger.dataset.streetlovoNewsletterCloseBound === 'true') return;
        trigger.dataset.streetlovoNewsletterCloseBound = 'true';
        trigger.addEventListener('click', function() {
          self.close();
        });
      });

      if (!this.keydownBound) {
        this.keydownBound = true;
        document.addEventListener('keydown', function(e) {
          if (e.key === 'Escape' && self.isOpen()) {
            self.close();
          }

          if (e.key === 'Tab' && self.isOpen()) {
            self.trapFocus(e);
          }
        });
      }
    },

    scheduleAutoShow: function() {
      if (this.popup.dataset.streetlovoNewsletterAutoShowScheduled === 'true') return;
      if (this.popup.dataset.showOnLoad !== 'true') return;

      this.popup.dataset.streetlovoNewsletterAutoShowScheduled = 'true';
      const delay = parseInt(this.popup.dataset.delay || '3000', 10);

      this.autoShowTimer = window.setTimeout(() => {
        if (!localStorage.getItem('newsletterClosed')) {
          this.open({ restoreFocus: false });
        }
      }, Number.isNaN(delay) ? 3000 : delay);
    },

    openFormState: function() {
      const stateEl = this.popup.querySelector('[data-newsletter-form-state]');
      if (!stateEl) return false;

      if (stateEl.dataset.newsletterFormState === 'success') {
        localStorage.setItem('newsletterClosed', 'true');
      }

      this.open({ restoreFocus: false });
      window.setTimeout(function() {
        stateEl.focus();
      }, 0);

      return true;
    },

    isOpen: function() {
      return this.popup && this.popup.classList.contains('streetlovo-newsletter--open');
    },

    open: function(options = {}) {
      if (this.popup) {
        this.lastActiveElement = options.restoreFocus === false ? null : document.activeElement;
        this.popup.classList.add('streetlovo-newsletter--open');
        this.popup.setAttribute('aria-hidden', 'false');

        const focusTarget = this.popup.querySelector('.streetlovo-newsletter__close, input, button, a');
        if (focusTarget) {
          window.setTimeout(function() {
            focusTarget.focus();
          }, 0);
        }
      }
    },

    close: function() {
      if (this.popup) {
        this.popup.classList.remove('streetlovo-newsletter--open');
        this.popup.setAttribute('aria-hidden', 'true');
        localStorage.setItem('newsletterClosed', 'true');

        if (this.lastActiveElement && typeof this.lastActiveElement.focus === 'function') {
          this.lastActiveElement.focus();
        }
        this.lastActiveElement = null;
      }
    },

    trapFocus: function(e) {
      const focusable = this.popup.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), textarea:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])');
      if (!focusable.length) return;

      const first = focusable[0];
      const last = focusable[focusable.length - 1];

      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  };

  /**
   * Mobile Menu - Slide Down
   */
  Streetlovo.mobileMenu = {
    menu: null,
    closeTimer: null,

    init: function() {
      this.menu = document.querySelector('[data-mobile-menu]');
      this.bindEvents();
    },

    bindEvents: function() {
      const self = this;
      const toggle = document.querySelector('[data-mobile-menu-toggle]');

      if (toggle) {
        toggle.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          self.toggle();
        });
      }

      // Close when clicking any link inside menu
      if (this.menu) {
        this.menu.querySelectorAll('a, button').forEach(function(link) {
          link.addEventListener('click', function() {
            self.close();
          });
        });
      }
    },

    toggle: function() {
      if (this.menu) {
        if (this.menu.classList.contains('mobile-nav--open')) {
          this.close();
        } else {
          this.open();
        }
      }
    },

    open: function() {
      if (this.menu) {
        if (window.Streetlovo?.cartDrawer?.state?.isOpen) {
          window.Streetlovo.cartDrawer.close();
        }
        window.clearTimeout(this.closeTimer);
        this.menu.classList.add('mobile-nav--open');
        document.body.classList.add('menu-open');
        document.body.style.overflow = 'hidden';
      }
    },

    close: function() {
      if (this.menu) {
        this.menu.classList.remove('mobile-nav--open');
        document.body.classList.remove('menu-open');
        window.clearTimeout(this.closeTimer);
        this.closeTimer = window.setTimeout(function() {
          if (!window.Streetlovo?.cartDrawer?.state?.isOpen) {
            document.body.style.overflow = '';
          }
        }, 300);
      }
    }
  };

  /**
   * Cart Page - Terms validation
   */
  Streetlovo.cartPage = {
    init: function() {
      const form = document.querySelector('.streetlovo-cart-page__form');
      if (!form) return;

      const termsCheckbox = document.getElementById('cart-terms-page');
      const checkoutBtn = form.querySelector('button[name="checkout"]');

      if (checkoutBtn && termsCheckbox) {
        checkoutBtn.addEventListener('click', function(e) {
          if (!termsCheckbox.checked) {
            e.preventDefault();
            alert('Please agree to the terms and conditions');
          }
        });
      }
    }
  };

  /**
   * Product add fallback used when the cart drawer is unavailable.
   */
  Streetlovo.addProductToCart = async function(payload, quantity = 1) {
    try {
      const isFormData = payload instanceof FormData;
      const response = await fetch(`${window.routes.cart_add_url}.js`, {
        method: 'POST',
        headers: isFormData
          ? { 'Accept': 'application/json' }
          : {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
        body: isFormData ? payload : JSON.stringify({ id: payload, quantity })
      });

      const data = await response.json();
      if (!response.ok || data.status === 422) {
        throw new Error(data.description || 'Could not add item to cart');
      }

      return { success: true, item: data };
    } catch (error) {
      console.error('[Streetlovo] Cart add fallback error:', error);
      return { success: false, error };
    }
  };

  // Expose globally
  window.Streetlovo = Streetlovo;

  /**
   * Initialize all modules
   */
  document.addEventListener('DOMContentLoaded', function() {
    Streetlovo.newsletter.init();
    Streetlovo.mobileMenu.init();
    Streetlovo.cartPage.init();
  });

  document.addEventListener('shopify:section:load', function() {
    Streetlovo.newsletter.init();
  });
})();
